import React from 'react';

import Icon from 'components/Icon';

export default class AssignmentDetailsGrid extends React.Component {
    static propTypes = {
        assignment: React.PropTypes.object.isRequired,
        handleContentClick: React.PropTypes.func.isRequired,
        handlePinpointsClick: React.PropTypes.func.isRequired,
        handleUsersClick: React.PropTypes.func.isRequired,
        inEditModal: React.PropTypes.bool
    }

    _calculateUserCount() {
        if(this.props.assignment.users == null) {
            return 0;
        }

        let userCount = this.props.assignment.users.length;

        this.props.assignment.groups.forEach((group) => {
            userCount += group.userIds.length;
        })

        return userCount;
    }

    render() {
        let { assignment, handleContentClick, handlePinpointsClick, handleUsersClick, inEditModal } = this.props;
        return (
            <div className="assignment-details__status-grid details-modal__info">
                <div className="assignment-details__status" onClick={handleContentClick.bind(this)}>
                    <div className="assignment-details__status-name">
                        {inEditModal === true ? 'Add ' : ''}Content
                    </div>
                    <div className="assignment-details__status-icon">
                        <Icon icon="content" />
                    </div>
                    <div className="assignment-details__status-number">
                        {assignment.contents != null ? assignment.contents.length : 0}
                    </div>
                </div>
                <div className="assignment-details__status" onClick={handleUsersClick.bind(this)}>
                    <div className="assignment-details__status-name">
                        {inEditModal === true ? 'Add ' : ''}Users
                    </div>
                    <div className="assignment-details__status-icon">
                        <Icon icon="groups" />
                    </div>
                    <div className="assignment-details__status-number">
                        {this._calculateUserCount()}
                    </div>
                </div>
                <div className="assignment-details__status" onClick={handlePinpointsClick.bind(this)}>
                    <div className="assignment-details__status-name">
                        {inEditModal === true ? 'Add ' : ''}PinPoints
                    </div>
                    <div className="assignment-details__status-icon">
                        <Icon icon="pinpoints" />
                    </div>
                    <div className="assignment-details__status-number">
                        {assignment.beacons != null ? assignment.beacons.length : 0}
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/containers/AssignmentsPage/modals/AssignmentDetailsGrid.js